// AUTO-GENERATED by scripts/harvest-ai-screens.mjs — do not edit by hand.
// Run `node scripts/harvest-ai-screens.mjs` (also runs on `npm run build`).
//
// The complete navigable route map, derived from app/pages/**. Gives the AI
// assistant step-by-step navigation knowledge for EVERY feature; rich
// summaries/prompts for key screens are layered on top in screens.ts.

export interface GeneratedScreen {
  route: string
  title: string
  parent: string | null
}

export const GENERATED_SCREENS: GeneratedScreen[] = [
  { route: "/", title: "Dashboard", parent: null },
  { route: "/affiliates", title: "Affiliates", parent: "/" },
  { route: "/api-documentation", title: "API Docs", parent: "/" },
  { route: "/billing", title: "Billing", parent: "/" },
  { route: "/billing/:id", title: "Billing details", parent: "/billing" },
  { route: "/billing/checkout", title: "Checkout", parent: "/billing" },
  { route: "/billing/settings/:id", title: "Settings details", parent: "/billing/settings" },
  { route: "/changelog", title: "Changelog", parent: "/" },
  { route: "/clone-wizard", title: "Clone Wizard", parent: "/" },
  { route: "/configure", title: "Configure", parent: "/" },
  { route: "/discover", title: "Discover", parent: "/" },
  { route: "/images", title: "Images", parent: "/" },
  { route: "/instances", title: "Instances", parent: "/" },
  { route: "/instances/:id", title: "Instances details", parent: "/instances" },
  { route: "/instances/:id/backups", title: "Backups", parent: "/instances/:id" },
  { route: "/instances/:id/console", title: "Console", parent: "/instances/:id" },
  { route: "/instances/:id/hardware", title: "Hardware", parent: "/instances/:id" },
  { route: "/instances/:id/monitoring", title: "Monitoring", parent: "/instances/:id" },
  { route: "/instances/:id/networking", title: "Networking", parent: "/instances/:id" },
  { route: "/instances/:id/security", title: "Security", parent: "/instances/:id" },
  { route: "/instances/:id/settings", title: "Settings", parent: "/instances/:id" },
  { route: "/instances/:id/snapshots", title: "Snapshots", parent: "/instances/:id" },
  { route: "/iso", title: "ISO Images", parent: "/" },
  { route: "/network/dns", title: "DNS", parent: "/network" },
  { route: "/network/dns/:zoneId", title: "DNS details", parent: "/network/dns" },
  { route: "/network/firewall", title: "Firewall", parent: "/network" },
  { route: "/network/firewall/:id", title: "Firewall details", parent: "/network/firewall" },
  { route: "/network/rdns", title: "Reverse DNS", parent: "/network" },
  { route: "/network/vpc", title: "VPC", parent: "/network" },
  { route: "/network/vpc/:id", title: "VPC details", parent: "/network/vpc" },
  { route: "/news", title: "News", parent: "/" },
  { route: "/resize-wizard", title: "Resize Wizard", parent: "/" },
  { route: "/security", title: "Security", parent: "/" },
  { route: "/security/findings", title: "Findings", parent: "/security" },
  { route: "/settings", title: "Settings", parent: "/" },
  { route: "/settings/activity", title: "Activity", parent: "/settings" },
  { route: "/settings/api-tokens", title: "API Tokens", parent: "/settings" },
  { route: "/settings/notifications", title: "Notifications", parent: "/settings" },
  { route: "/vpn-gateway", title: "VPN Gateway", parent: "/" },
  { route: "/vpn-gateway/checkout", title: "Checkout", parent: "/vpn-gateway" },
  { route: "/vpn-gateway/details/:downloadCode", title: "Details details", parent: "/vpn-gateway/details" },
  { route: "/vpn-gateway/site-to-site", title: "Site To Site", parent: "/vpn-gateway" },
  { route: "/vpn-gateway/site-to-site/:connectionId", title: "Site To Site details", parent: "/vpn-gateway/site-to-site" },
  { route: "/vpn-gateway/site-to-site/new", title: "New", parent: "/vpn-gateway/site-to-site" },
  { route: "/vpn-gateway/users", title: "VPN Users", parent: "/vpn-gateway" },
]
